var _rect, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisSearchIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#9694E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_129317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7141 16.8088H29.2443V11.1942V9.66406H27.7141H20.1582V11.1942H27.7141V16.8088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3259 22.2188H12.7949V28.8044V30.3329H14.3259H18.9678V28.8044H14.3259V22.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4824 27.7939H34.7034V19.0391H21.4824V27.7939ZM22.0995 19.7066H34.0854V27.1263H22.0995V19.7066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9863 29.4468L34.7021 28.2344H21.424L21.1465 29.4468H21.1348V30.1421H34.9997V29.4468H34.9863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3457 18.4206H18.5667V9.66406H5.3457V18.4206ZM5.9645 10.3325H17.9504V17.7522H5.9645V10.3325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8515 20.0779L18.5673 18.8672H5.2909L5.01345 20.0779H5V20.7732H18.8658V20.0779H18.8515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_129317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_Search_Icon.8df54f27.svg";
export { ForwardRef as ReactComponent };